import { render, staticRenderFns } from "./StudentTransferListPage.vue?vue&type=template&id=685fbd72&scoped=true"
import script from "./StudentTransferListPage.vue?vue&type=script&lang=js"
export * from "./StudentTransferListPage.vue?vue&type=script&lang=js"
import style0 from "./StudentTransferListPage.vue?vue&type=style&index=0&id=685fbd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685fbd72",
  null
  
)

export default component.exports